import {Cookies} from "react-cookie";

export const COOKIE_CONSENT_NAME = "FETURA_COOKIE_CONSENT";
export const LEGACY_COOKIE_CONSENT_NAME = "CANIHAZCOOKIEZ";
export const COOKIE_CONSENT_VERSION = 1;

const ONE_YEAR_IN_MILLISECONDS = 365 * 24 * 60 * 60 * 1000;

export function getCookieConsentOptions() {
    return {
        path: "/",
        sameSite: "lax",
        secure:
            typeof window !== "undefined" &&
            window.location.protocol === "https:",
        expires: new Date(Date.now() + ONE_YEAR_IN_MILLISECONDS),
    };
}

export function normalizeCookieConsent(value) {
    let consent = value;

    if (typeof consent === "string") {
        try {
            consent = JSON.parse(consent);
        } catch (error) {
            return null;
        }
    }

    if (
        !consent ||
        consent.version !== COOKIE_CONSENT_VERSION ||
        typeof consent.analytics !== "boolean"
    ) {
        return null;
    }

    return consent;
}

export function getStoredCookieConsent() {
    if (typeof document === "undefined") return null;
    return normalizeCookieConsent(new Cookies().get(COOKIE_CONSENT_NAME));
}

export function hasAnalyticsConsent() {
    return getStoredCookieConsent()?.analytics === true;
}

export function setGoogleAnalyticsDisabled(disabled) {
    const measurementId = process.env.REACT_APP_ANALYTICS_TOKEN;
    if (typeof window === "undefined" || !measurementId) return;
    window[`ga-disable-${measurementId}`] = disabled;
}

function getCookieDomains() {
    if (typeof window === "undefined") return [];

    const hostname = window.location.hostname;
    const hostnameParts = hostname.split(".");
    const domains = new Set([hostname, `.${hostname}`]);

    for (let index = 1; index < hostnameParts.length - 1; index++) {
        const parentDomain = hostnameParts.slice(index).join(".");
        domains.add(parentDomain);
        domains.add(`.${parentDomain}`);
    }

    return [...domains];
}

export function removeGoogleAnalyticsCookies() {
    if (typeof document === "undefined") return;

    const cookies = new Cookies();
    const analyticsCookieNames = Object.keys(cookies.getAll()).filter(
        (name) => name === "_ga" || name.startsWith("_ga_")
    );

    analyticsCookieNames.forEach((name) => {
        cookies.remove(name, {path: "/"});
        getCookieDomains().forEach((domain) => {
            cookies.remove(name, {path: "/", domain});
        });
    });
}
